import React, { useState } from "react";

import {
  Box,
  Button,
  HStack,
  Input,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Text
} from "@chakra-ui/react";

interface AddDepartmentProps {
  addDepartmentDisclosure: any;
  isAddingDepartment: any;
  handleSubmitAddDepartment: any;
}

export const AddDepartment: React.FC<AddDepartmentProps> = ({
  addDepartmentDisclosure,
  isAddingDepartment,
  handleSubmitAddDepartment
}) => {
  const [name, setName] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    handleSubmitAddDepartment({ name });
  };

  return (
    <Modal
      isCentered
      size="2xl"
      closeOnOverlayClick={false}
      motionPreset="slideInBottom"
      {...addDepartmentDisclosure}
    >
      <ModalOverlay />
      <ModalContent w={618} py={10} px={10}>
        <ModalCloseButton top={10} right={8} />
        <Box w="full">
          <Text
            fontWeight={600}
            color="secondary.600"
            fontSize="xl"
            pt={0}
            pb={2}
          >
            Create new department
          </Text>

          <Stack
            w="full"
            as="form"
            onSubmit={handleSubmit}
            mt={15}
            spacing={35}
          >
            <Stack spacing={1}>
              <Text fontSize={14} fontWeight={500}>
                Department name
              </Text>
              <Input
                size="sm"
                isRequired
                h={10}
                onChange={(event) => setName(event.target.value)}
                placeholder="eg. Founders, Payments, Approvers.."
                value={name}
                variant="outline"
              />
            </Stack>

            <HStack justify="flex-end" spacing={3} pt={0}>
              <Button
                h={9}
                size="sm"
                variant="outline"
                onClick={addDepartmentDisclosure.onClose}
              >
                Close
              </Button>
              <Button
                h={9}
                size="sm"
                w={167}
                isLoading={isAddingDepartment}
                loadingText="Saving..."
                type="submit"
              >
                Create Department
              </Button>
            </HStack>
          </Stack>
        </Box>
      </ModalContent>
    </Modal>
  );
};
